{
  "AUTHORIZED_INDIVIDUAL": "Individu autorisé",
  "BENEFICIAL_OWNER": "Propriétaire bénéficiaire",
  "CHILD": "Enfant",
  "FRIEND": "Ami(e)",
  "GRANDCHILD": "Petit-enfant",
  "GRANDPARENT": "Grand-parent",
  "GRANTOR": "Donateur",
  "NIECE_NEPHEW": "Nièce/neveu",
  "OTHER": "Autre",
  "PARENT": "Parent",
  "POWER_OF_ATTORNEY": "Procuration",
  "PROTECTOR": "Protecteur",
  "SETTLOR": "Constituant",
  "SIBLING": "Frère ou sœur",
  "SPOUSE": "Époux",
  "THIRD_PARTY": "Tiers",
  "TRUSTED_CONTACT": "Contact de confiance",
  "TRUSTEE": "Fiduciaire",
  "DIRECTOR": "Directeur",
  "SENIOR_OFFICER": "Officier supérieur"
}
